import React, { useEffect, useState } from "react";
import Navbar from "../Component/Navbar";
import "./Homepage.css";
import tr1 from "../tr1.png";
import tr2 from "../tr2.png";
import tr3 from "../tr3.png";
import tr5 from "../tr5.png";
import tr6 from "../tr6.png";

export default function HomePage() {

  // ---------------- SCROLL FADE EFFECT ---------------- //
  useEffect(() => {
    const elements = document.querySelectorAll(".fade-section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  // ---------------- SLIDER LOGIC ---------------- //
  const slides = [
    { img: tr1, title: "Live Technical Training" },
    { img: tr2, title: "Hands-on Practice Sessions" },
    { img: tr3, title: "Cloud & DevOps Lab" },
    { img: tr5, title: "Career Guidance & Placement Support" },
    { img: tr6, title: "Expert Instructors" }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="homepage">
      <Navbar />

      {/* ================= HERO ================= */}
      <section className="hero">
        <h1 className="hero-title fade-section">
          Welcome to TechSign Solutions
        </h1>

        <p className="hero-subtitle fade-section">
          A Leading IT Training Organization offering Real-Time Training, 
          Live Projects & Placement Support for Students and Professionals.
        </p>

        <button className="hero-btn fade-section">Explore Courses</button>
      </section>

      {/* ================= HIGHLIGHTS ================= */}
      <section className="highlights">
        <h2 className="highlight-title fade-section">Why Choose Us?</h2>

        <div className="highlight-grid">
          <div className="highlight-card fade-section">
            <h3>Real-Time Training</h3>
            <p>Courses designed by industry experts with hands-on projects.</p>
          </div>

          <div className="highlight-card fade-section">
            <h3>Placement Support</h3>
            <p>Resume building, interview preparation, and job assistance.</p>
          </div>

          <div className="highlight-card fade-section">
            <h3>Expert Trainers</h3>
            <p>Learn from certified professionals with 10+ years experience.</p>
          </div>
        </div>
      </section>

      {/* ================= COURSES ================= */}
      <section className="courses">
        <h2 className="section-title fade-section">Our Popular Courses</h2>

        <div className="courses-grid">
          <div className="course-box fade-section">
            <h3>MERN Full Stack Development</h3>
            <p>React, Node.js, MongoDB, Express + Live Project</p>
          </div>

          <div className="course-box fade-section">
            <h3>AWS Cloud & DevOps</h3>
            <p>AWS, Docker, Kubernetes, CI/CD, Terraform</p>
          </div>

          <div className="course-box fade-section">
            <h3>Python & Machine Learning</h3>
            <p>Data Science, ML Models, Pandas, NumPy</p>
          </div>

          <div className="course-box fade-section">
            <h3>Cyber Security</h3>
            <p>Ethical Hacking, Pen Testing, SOC Tools</p>
          </div>
        </div>
      </section>

      {/* ================= TRAINING IMAGE SLIDER (BEFORE ABOUT) ================= */}
      <section className="training-slider">
        <h2 className="section-title fade-section">
          Our Training & Classroom Sessions
        </h2>

        <div className="slider-container fade-section">
          <img
            src={slides[currentSlide].img}
            alt="Training Slide"
            className="slider-image"
          />

          <div className="slider-overlay">
            <h3 className="slider-title">
              {slides[currentSlide].title}
            </h3>
          </div>
        </div>

        <div className="slider-dots">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentSlide ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
            ></span>
          ))}
        </div>
      </section>

      {/* ================= ABOUT ================= */}
      <section className="about">
        <div className="about-content fade-section">
          <h2>About TechSign Solutions</h2>
          <p>
            TechSign Solutions is a leading IT Training Institute focused on 
            delivering real-time, industry-ready skills. Our programs are 
            designed with the latest technologies and are taught by certified 
            experts with hands-on projects, live labs, and placement support.
          </p>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer className="footer fade-section">
        © {new Date().getFullYear()} TechSign Solutions. All rights reserved.
      </footer>

    </div>
  );
}
